import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var truncate = {
  name: "1hfn09t",
  styles: "display:flex;flex-wrap:nowrap;width:100%;overflow:hidden;gap:4px;"
};
export var wrap = {
  name: "yi3mkw",
  styles: "display:flex;flex-wrap:wrap;gap:4px;"
};
export var newline = {
  name: "1kkt86i",
  styles: "display:flex;flex-direction:column;gap:4px;"
};
export var overflow = /*#__PURE__*/css("white-space:nowrap;color:", colors.neutral.heavy.default, ";");